import * as React from 'react';
import { Box } from 'rebass';
import uuid from 'uuid/v1';
export default function Upload(_a) {
    var _b = _a.accept, accept = _b === void 0 ? '*' : _b, _c = _a.id, id = _c === void 0 ? uuid() : _c, onUpload = _a.onUpload, width = _a.width, children = _a.children;
    return (React.createElement(React.Fragment, null,
        React.createElement(Box, { as: "label", htmlFor: id, width: width }, children),
        React.createElement(Box, { as: "input", id: id, accept: accept, type: "file", onChange: onUpload, sx: { display: 'none' } })));
}
